import { Button, Datepicker, Dropdown, TextInput } from 'flowbite-react'
import React, { useEffect, useState } from 'react'
import filterIcon from '../../../../assets/filterIcon.png'
import { FaEllipsisH, FaSearch } from 'react-icons/fa'
import downloadIcon from '../../../../assets/document-download.png'
import CustomTable from '../../../../components/Table/CustomTable'
import { ColumnUsers, UsersData } from '../../../../types/TablesTypes/Users'
import CustomModal from '../../../../components/Modal/CustomModal'
import CreateUsers from './CreateUsers'
import icon from '../../../../assets/shareholdersIcon.png'
import client from '../../../../api/client'
import moment from 'moment'
import StatusView from '../../../../components/StatusView/StatusView'

const Users = () => {
    const options = [
        "Pending",
        "Approved"
    ]

    const [selectedOption, setSelectedOption] = useState<any>(options[0])
    const [users, setUsers] = useState<any[]>([])
    const [tableRow, setTableRow] = useState<any[]>([])
    const [openModal, setOpenModal] = useState(false)
    const [loading, setLoading] = useState<boolean>(true);


    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)
            await getUsers()
            setLoading(false)
        }
        fetchData()
    }, [])

    const getUsers = async () => {
        try {
            const response = await client.get('/subsidiary/dashboard/users/all');

            setUsers(response.data.users);
            const message = response?.data?.message;

        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
            }
        }
    }

    const dataPaymentLinks = () => {
        const tempArr: UsersData[] = [];
        users
            .forEach((user: any, index: number) => {
                tempArr.push({
                    emailAddress: user.emailAddress,
                    fullName: `${user.firstName} ${user.lastName}`,
                    mobileNumber: user.mobileNumber,
                    role: user.role,
                    status: (
                        <StatusView
                            status={user.status}
                            green='Active'
                            red='Inactive'
                            orange='New'
                        />
                    ),
                    userId: user.userId,
                    addedByUserName: user.addedByUserName,
                    dateCreated: moment(user?.dateAdded).format('MMMM Do YYYY, h:mm a'),
                    action: (<Dropdown label={
                        <FaEllipsisH />
                    } inline arrowIcon={false}>
                        <Dropdown.Item>Update Role</Dropdown.Item>
                        <Dropdown.Item>Deactivate</Dropdown.Item>
                    </Dropdown>)
                });
            });
        return tempArr;
    };

    useEffect(() => {
        setTableRow(dataPaymentLinks());
    }, [users]);
  return (
    <div>
       <div>
            <div className='flex items-center flex-wrap'>
                <div className='flex items-center gap-3'>
                    <Datepicker /> to <Datepicker />
                    <div className='bg-custom-button-green py-2 px-3 rounded-sm'>
                        <Dropdown
                            label={
                                <div className='flex items-center gap-2 text-sm '>
                                    <div>
                                        <img src={filterIcon} alt='Filter' />
                                    </div>
                                    <p>{selectedOption}</p>
                                </div>
                            }
                            inline
                            dismissOnClick={true}
                        >
                            {options.map(option => (
                                <Dropdown.Item onClick={() => setSelectedOption(option)}>{option}</Dropdown.Item>
                            ))}
                        </Dropdown>
                    </div>

                </div>
                <div className='flex items-center gap-3 ml-auto'>
                    <div className='items-center'>
                        <TextInput icon={FaSearch} name='search' placeholder='Search' />

                    </div>
                    <Button className='rounded-md bg-black'>
                        <div className='flex gap-2'>
                            <img src={downloadIcon} alt="Download" />
                            <span>Export</span>
                        </div>
                    </Button>
                    <Button className='rounded-sm bg-green-800' onClick={() => setOpenModal(true)}>
                        Create New User
                    </Button>
                </div>
            </div>
            <div className='my-8'>
                <CustomTable headings={ColumnUsers} data={tableRow ? tableRow : []} loading={loading} emptyMessage='You do not have any users' />
            </div>
            <CustomModal title='Create New User' children={<CreateUsers close={()=>setOpenModal(false)} getUsers={getUsers} />} dismissible={true} show={openModal} icon={icon} onClose={() => setOpenModal(false)} size='md' />
        </div >
    </div>
  )
}

export default Users